var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 2.49998H10.35C10 1.53331 9.08333 0.833313 8 0.833313C6.91667 0.833313 6 1.53331 5.65 2.49998H2.16667C1.25 2.49998 0.5 3.24998 0.5 4.16665V15.8333C0.5 16.75 1.25 17.5 2.16667 17.5H13.8333C14.75 17.5 15.5 16.75 15.5 15.8333V4.16665C15.5 3.24998 14.75 2.49998 13.8333 2.49998ZM8 2.49998C8.45833 2.49998 8.83333 2.87498 8.83333 3.33331C8.83333 3.79165 8.45833 4.16665 8 4.16665C7.54167 4.16665 7.16667 3.79165 7.16667 3.33331C7.16667 2.87498 7.54167 2.49998 8 2.49998ZM6.33333 14.1666L3 10.8333L4.175 9.65831L6.33333 11.8083L11.825 6.31665L13 7.49998L6.33333 14.1666Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedReport);
export default __webpack_public_path__ + "static/media/completedReport.69ae29fafd783e95e83cb4c58dea293a.svg";
export { ForwardRef as ReactComponent };